import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { DesignSystemComponentsModule } from '@montebravo.tech/design-system-components';
import { DesignSystemNavigationModule } from '@montebravo.tech/design-system-navigation';

import { CommissionsModule } from './commissions/commissions.module';
import { WealthServicesRoutingModule } from './wealth-services-routing.module';
import { WealthServicesComponent } from './wealth-services.component';

@NgModule({
    declarations: [WealthServicesComponent],
    imports: [
        CommonModule,
        DesignSystemComponentsModule,
        MatIconModule,
        WealthServicesRoutingModule,
        DesignSystemNavigationModule,
        CommissionsModule,
    ],
    providers: [],
})
export class WealthServicesModule {}
